import { message } from "antd";

export const upsertChatsByTenant = (state, action) => {
  const { data, tenant_id } = action.payload;
  const { type } = action?.meta?.arg || {};
  data?.forEach((chat) => {
    if (!state.chatsByTenants?.[tenant_id]) {
      state.chatsByTenants = {
        [tenant_id]: {},
      };
    }
    state.chatsByTenants[tenant_id][chat?.id] = chat;
  });

  const chatId = data?.[0]?.id;

  if (type === "create" && chatId) state.selectedChatId = chatId;
  
  state.loading = false;
};

export const handleAddUpdateCheckpointFulfilled = (state, action) => {
  const { tenant_id, conversation_id, id } = action.meta.arg;
  const { data, message: successMessage } = action.payload;

  const chat = state.chatsByTenants?.[tenant_id]?.[conversation_id];
  if (!chat) return;

  chat.checklists = chat.checklists || [];

  if (id) {
    // 🔁 UPDATE existing checkpoint
    const index = chat.checklists.findIndex((item) => item.id === id);

    if (index !== -1) {
      chat.checklists[index] = {
        ...chat.checklists[index],
        ...data,
      };
    }
  } else {
    // ➕ ADD new checkpoint
    chat.checklists.push(data);
  }

  message.success(
    successMessage ||
      (id
        ? "Check Point Updated Successfully"
        : "Check Point Added Successfully"),
  );
};

export const handleSendWebSocketMessage = (state, action) => {
  const payload = action.payload;
  if (payload?.action === "updateReaction") {
    const chat =
      state.chatsByTenants[payload?.tenant_id]?.[payload?.conversation_id];

    if (!chat?.messages) return;

    chat.messages?.forEach((m) => {
      if (m.id !== payload?.data?.message_id) return;

      const { sender_id, emoji, sender_type } = payload.data;

      let found = false;

      m.reactions = (m.reactions || []).reduce((acc, r) => {
        if (r.sender_id === sender_id) {
          found = true;

          if (r.emoji !== emoji) {
            acc.push({ sender_id, emoji, sender_type });
          }
        } else {
          acc.push(r);
        }
        return acc;
      }, []);

      if (!found) {
        m.reactions.push({ sender_id, emoji, sender_type });
      }
    });
  } else {
    const messages = Array.isArray(payload)
      ? payload.map((p) => p.tempMessage)
      : [payload.tempMessage];

    messages.forEach((tempMessage) => {
      const chat =
        state.chatsByTenants[tempMessage?.tenant_id]?.[
          tempMessage?.conversation_id
        ];

      if (chat) chat.messages = [...(chat.messages || []), tempMessage];
    });
  }
};
